import yelloHotelLogo from "../images/yelloHotelLogo.png";

const OurPartner = () => {
  return (
    <section className="Partner-section">
      <div className="partner-container">
        <p className="homePage-title" style={{ color: "white" }}>
          Our Partner
        </p>
        <div className="box">
          <div className="col-4">
            <img src={yelloHotelLogo} alt="" />
          </div>
          <div className="col-4"></div>
          <div className="col-4"></div>
          <div className="col-4"></div>
          <div className="col-4"></div>
        </div>
      </div>
      {/* <div className="partner-footer">
        <button className="viewAllButton" style={{ color:}}>View All</button>
      </div> */}
    </section>
  );
};

export default OurPartner;
